import React, { Fragment, useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import useRequests from "../../../utils/useRequests";
import "react-datepicker/dist/react-datepicker.css";
import * as Yup from "yup";
import { useFormik } from "formik";
import Snackbars from "../../../utils/Snackbars";
import Select from "react-select";

const AddExistingUser = () => {
  const navigate = useNavigate();
  const { postRequest, getRequest } = useRequests();

  const [AlertData, setAlertData] = React.useState({
    variant: "",
    message: "",
  });

  const [users, setUsers] = useState([]);
  const [userOptions, setUserOptions] = useState([]);
  const [inputValue, setInputValue] = useState("");

  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData({
        variant: "",
        message: "",
      });
    }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
  };

  const fetchUsers = async () => {
    const response = await getRequest("all-user-list");
    if (response && response.code === 200) {
      const enabledUsers = response.data.filter(
        (user) => user.status === "Enable"
      );
      console.log(enabledUsers)
      const options = enabledUsers.map((user) => ({
        value: user.u_id,
        label: `${user.phone ? "[ " + user.phone + " ]" : ""}`,
      }));
      setUsers(enabledUsers);
      setUserOptions(options);
    } else {
      setAlertData({
        variant: "error",
        message: "Failed to fetch users",
      });
    }
    resetAlertData();
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const validation1 = useFormik({
    enableReinitialize: true,
    initialValues: {
      u_id: "",
    },
    validationSchema: Yup.object({
      u_id: Yup.string().required("User is required"),
    }),
    onSubmit: async (values) => {
      try {
        let submit1 = document.getElementById("submit1");
        submit1.disabled = true;
        submit1.textContent = "Processing...";

        const jsonpar = JSON.stringify({
          u_id: values.u_id,
        });

        const res = await postRequest("existing-user-add", jsonpar);

        if (res && res.code === 200) {
          validation1.resetForm();
          navigate("/user-list", {
            state: {
              variant: "success",
              message: "User added successfully!",
            },
          });
        } else {
          setAlertData({
            variant: "error",
            message: res.message || "Failed to add user.",
          });
          resetAlertData();
        }

        submit1.disabled = false;
        submit1.textContent = "Add User";
      } catch (error) {
        console.error("Error: ", error);
        setAlertData({
          variant: "error",
          message: "An error occurred while adding the user.",
        });
        resetAlertData();
      }
    },
  });

  const handleSelectChangeUser = (selectedOption) => {
    validation1.setFieldValue("u_id", selectedOption?.value || "");
  };

  // Filter options based on input
  const filteredOptions = inputValue
    ? userOptions.filter((option) =>
        option.label.toLowerCase().includes(inputValue.toLowerCase())
      )
    : [];

  return (
    <Fragment>
      <div className="d-sm-flex d-block justify-content-between align-items-center mb-4">
        <h2 className="text-black font-w700 mb-0">Add User</h2>
      </div>

      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <div className="basic-form">
              {AlertData.message !== "" && (
                <Snackbars
                  variant={AlertData.variant}
                  message={AlertData.message}
                />
              )}
              <form>
                <div className="row mb-3">
                  <div className="form-group mb-3 col-md-8 col-xs-12">
                    <label>Select User :</label>
                    <Select
                      options={filteredOptions}
                      onChange={handleSelectChangeUser}
                      onInputChange={(value) => setInputValue(value)}
                      placeholder="Type to search user..."
                      isClearable
                      classNamePrefix="react-select"
                      styles={{
                        option: (provided, state) => ({
                          ...provided,
                          paddingTop: 12,
                          paddingBottom: 12,
                          fontSize: 15,
                          color: "black",
                          backgroundColor: state.isFocused
                            ? "#f0f0f0"
                            : "white",
                        }),
                        control: (provided) => ({
                          ...provided,
                          minHeight: 50,
                          color: "black",
                        }),
                        singleValue: (provided) => ({
                          ...provided,
                          color: "black",
                        }),
                        placeholder: (provided) => ({
                          ...provided,
                          color: "#888",
                        }),
                        menu: (provided) => ({
                          ...provided,
                          maxHeight: 300,
                        }),
                      }}
                    />
                    {validation1.touched.u_id && validation1.errors.u_id && (
                      <div className="invalid-feedback d-block">
                        {validation1.errors.u_id}
                      </div>
                    )}
                  </div>
                </div>

                <button
                  type="submit"
                  className="btn btn-primary me-2 mt-3"
                  id="submit1"
                  onClick={(e) => {
                    e.preventDefault();
                    validation1.handleSubmit();
                    return false;
                  }}
                >
                  Add User
                </button>
                <Link to="/user-list" className="btn btn-light mt-3">
                  Cancel
                </Link>
              </form>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default AddExistingUser;
